import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ConceptSection() {
  const { t, i18n } = useTranslation();

  return (
    <ScrollReveal as="section" className="py-20 md:py-28 px-4 md:px-6 bg-transparent">
      <div className="max-w-4xl mx-auto text-center">
        <p className="font-heading text-xs md:text-sm tracking-[0.3em] text-accent-600 mb-4 reveal-child">
          {t('concept_label')}
        </p>
        <h2 className="font-heading text-2xl md:text-3xl tracking-wider text-foreground-900 mb-8 leading-relaxed reveal-child reveal-delay-1">
          {t('concept_title')}
        </h2>
        <div className="w-8 h-[1px] bg-accent-400 mx-auto mb-8 reveal-child reveal-delay-1" />
        <p className="text-sm md:text-base text-foreground-600 leading-loose max-w-2xl mx-auto reveal-child reveal-delay-2 whitespace-pre-line">
          {t('concept_desc')}
        </p>

        {/* X & JCB PREMIUM */}
        <div className="mt-10 flex flex-col items-center gap-5 reveal-child reveal-delay-3">
          <a
            href="https://x.com/takazusi_ikeb96"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-900 hover:border-foreground-600 transition-all duration-300"
            aria-label="X（旧Twitter）"
          >
            <i className="ri-twitter-x-fill text-xl" />
          </a>

          <div className="inline-block rounded-lg p-1 gold-gradient-shine">
            <div className="bg-red-700 rounded-md px-6 py-4 text-center">
              <div className="flex items-center justify-center gap-3 mb-2">
                <i className="ri-star-fill text-lg bg-gradient-to-b from-accent-200 via-accent-400 to-accent-600 bg-clip-text text-transparent" />
                <i className="ri-star-fill text-lg bg-gradient-to-b from-accent-200 via-accent-400 to-accent-600 bg-clip-text text-transparent" />
                <i className="ri-star-fill text-lg bg-gradient-to-b from-accent-200 via-accent-400 to-accent-600 bg-clip-text text-transparent" />
              </div>
              <p className="text-white text-xl md:text-2xl tracking-[0.2em] whitespace-nowrap">
                {i18n.language === 'ja' ? (
                  <>
                    <span className="font-heading">JCB THE PREMIUM</span>{' '}
                    <span className="font-kaisho">掲載店</span>
                  </>
                ) : (
                  t('concept_jcb')
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}